export default __webpack_public_path__ + "static/media/selectTeam4.cedd00d2.mp3";